
import { PartnerConnectForceTab } from "partner-connect/debug/menu/partner-connect-force-tab";
import { partnerConnectForcer } from "partner-connect/debug/menu/partner-connect-forcer";
import { DebugMenu } from "slotworks/debug/menu/debug-menu";
class PartnerConnectForceLoader {
    private YggForces: { [key: string]: string } = {};

    public setPartnerConnectForceData(forces: { [key: string]: string }) {
        this.YggForces = forces;
    }

    public populateForceMenu() {
        for (const key in this.YggForces) {
            if (this.YggForces[key]) {
                partnerConnectForcer.addCheat(key, this.YggForces[key]);
            }
        }

        DebugMenu.init();
        if (Object.keys(this.YggForces).length > 0) {
            DebugMenu.add(new PartnerConnectForceTab("PartnerConnect", partnerConnectForcer));
        }
    }
}

export const partnerConnectForceLoader = new PartnerConnectForceLoader();
